import { api, type ApiResponse } from './api'

/**
 * Resumen de la pantalla de inicio.
 *
 * Son cuatro cifras y ninguna se calcula en el cliente: el backend decide el
 * ámbito según el rol y lo devuelve ya hecho. «Facturadas» y «Clientes nuevos»
 * incluyen las ventas de tienda; «Cotizaciones del mes» no, porque abre el
 * listado de cotizaciones.
 */

/** Ámbito de las cifras: la empresa entera o solo lo del usuario. */
export type SummaryScope = 'company' | 'own'

export interface HomeSummary {
  scope: SummaryScope
  range: { from: string; to: string }
  quotes_month: number
  /** Solo cotizaciones facturadas en el mes. Se conserva por compatibilidad. */
  quotes_invoiced_month: number
  /** Cotizaciones facturadas más ventas de tienda facturadas en el mes. */
  invoiced_documents_month: number
  /**
   * Clientes cuya primera compra facturada —cotización o tienda— cayó en el
   * mes. No es el alta en el directorio: quien se registró y aún no compró no
   * es un cliente nuevo para ventas.
   *
   * `null` cuando el ámbito es el propio: la tabla de clientes no lleva autor,
   * así que no hay forma de saber quién los dio de alta. La vista no pinta esa
   * tarjeta en vez de enseñar un cero que parecería que no se ha dado de alta
   * ni uno.
   */
  new_customers: number | null
  pending_follow_ups: number
}

export const summaryApi = {
  get() {
    return api.get<ApiResponse<HomeSummary>>('/summary')
  },
}
